import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`Full Stack Dev & Designer | AI Enthusiast`}</h4>
    <p>{`I can handle pretty much any Data Collection and web app task. I have 2+ years of experience as a Developer and I am always Interested in using ML, DL and Other tech to Created best user experience.
I'm AI and Data Science enthusiast. Math, Bio and Robo lover who wants to put it all together. Check out My github to know more on what tech I use at `}<a parentName="p" {...{
        "href": "https://github.com/JDRanpariya"
      }}>{`Github`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      